import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/daisy';
import {
  ScheduledLessonStatusEnum,
  scheduledLessonStatusColors,
  scheduledLessonStatusVariants,
} from '@/utils/scheduledLessons/scheduledLessonStatus';

export type ScheduledLessonStatusBadgeProps = {
  status: ScheduledLessonStatusEnum;
};

export default function ScheduledLessonStatusBadge({
  status,
}: ScheduledLessonStatusBadgeProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'klassDetail.lessons.status',
  });

  return (
    <Badge
      size="md"
      variant={scheduledLessonStatusVariants[status]}
      className="truncate"
      color={scheduledLessonStatusColors[status]}
    >
      {t(status)}
    </Badge>
  );
}
